import { memo } from 'react';

import { cn } from '../../lib/styles';

export interface LinkButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color'> {
  element?: 'a' | 'button';
}

const LinkButtonBase = ({ className, element = 'button', href, ...rest }: LinkButtonProps) => {
  const Comp = href ? 'a' : element;

  return (
    <Comp
      className={cn(
        'font-body-md font-semibold',
        'text-text-primary underline cursor-pointer dark:text-white',
        'disabled:text-text-disabled disabled:no-underline disabled:cursor-default',
        className,
      )}
      href={href}
      {...(element === 'button' ? { type: 'button' } : {})}
      {...rest}
    />
  );
};

export const LinkButton = memo(LinkButtonBase);
